import profileImage from "./assets/images/users/erica.jpg";

import React, { useState, useEffect } from 'react';
export const activities = [
    {
      id: 1000,
      name: "Jet Ski",
      location: "Harmony Beach, Winnipeg, MB",
      description: "Experience the thrill of riding a jet ski on the open waters.",
      imgUrl: profileImage,
      thumbUrl: profileImage,
      timeSlots: [
        {
          date: "2024-05-20",
          times: [
            {
              time: "10:00 AM",
              availableTickets: 10,
              bookedTickets: 0,
              price: 100,
            },
            {
              time: "11:00 AM",
              availableTickets: 10,
              bookedTickets: 2,
              price: 100,
            },
          ],
        },
        {
          date: "2024-05-21",
          times: [
            {
              time: "10:00 AM",
              availableTickets: 10,
              bookedTickets: 5,
              price: 100,
            },
          ],
        },
      ],
      status: "On Sale",
    },
    {
      id: 1001,
      name: "Scuba Diving",
      location: "Coral Reef, Winnipeg, MB",
      description: "Dive deep into the waters and explore the underwater world.",
      imgUrl: profileImage,
      thumbUrl: profileImage,
      timeSlots: [
        {
          date: "2024-05-20",
          times: [
            {
              time: "10:00 AM",
              availableTickets: 20,
              bookedTickets: 8,
              price: 150,
            },
            {
              time: "11:00 AM",
              availableTickets: 20,
              bookedTickets: 10,
              price: 150,
            },
          ],
        },
        {
          date: "2024-05-21",
          times: [
            {
              time: "10:00 AM",
              availableTickets: 20,
              bookedTickets: 12,
              price: 150,
            },
          ],
        },
      ],
      status: "On Sale",
    },
    // Add more activities as needed
  ];
  
  // Functions to get activity by ID or bookings related to an activity
  export function getActivity(id) {
    return activities.find((event) => event.id.toString() === id);
  }

  
  
//   export async function getActivityBookings(id) {
//     const bookings = await getBookings(); // Assuming getBookings is defined elsewhere
//     return bookings.filter((order) => order.event.id.toString() === id);
//   }
  